import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { authHeaders, axiosInstance } from '../../../utils/helper';
import { apiUrlB2B } from '../../../utils/constants';
import { HeaderSlot } from '../../../utils/constants';
import Layout from '../../components/Layout';
import Header from '../../components/Header';
import Loader from '../../../components/Loader';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

const MenuDetail = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [detail, setDetail] = useState(null);

    useEffect(() => {
        if (!id) return;

        let isMounted = true;

        const fetchDetail = async () => {
            try {
                setLoading(true);

                const res = await axiosInstance.get(
                    `${apiUrlB2B}menu-ufoodx/${id}`,
                    authHeaders()
                );

                if (isMounted) {
                    setDetail(res?.data?.data || null);
                }
            } catch (err) {
                console.error("Error fetch detail:", err);
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        };

        fetchDetail();

        return () => {
            isMounted = false;
        };
    }, [id]);

    const fileUrl = detail?.contentFile;
    const isPDF = fileUrl?.toLowerCase().endsWith(".pdf");
    const headerProps = {
        slots: {
            left: {
              content: HeaderSlot.BACK,
            },
            center: {
              content: HeaderSlot.NAME,
              title: detail?.cmspageTitle,
              className: '!opacity-100 transform !translate-y-0 ml-2',
            },
            right: null,
        },
        parent: {
          border: {
            bottom: true,
          }
        }
    };

    return (
        <Layout>
            {loading && <Loader overlay className={'-mx-4 top-0'} />}
            <Header {...headerProps} />
            <div className="w-full rounded-lg overflow-y-auto flex-1 pt-8">
                {fileUrl && (
                    isPDF ? (
                        <iframe
                            src={fileUrl}
                            className="w-full h-full border-0"
                            title="PDF Viewer"
                        />
                    ) : (
                        <div className="w-screen h-[calc(100vh-80px)] overflow-y-auto pt-8">
                            <TransformWrapper
                                initialScale={1}
                                minScale={1}
                                maxScale={8}
                                doubleClick={{ disabled: true }}
                                wheel={{ disabled: false, step: 0.1 }}
                                pinch={{ step: 5 }}
                                panning={{ disabled: true }}
                                centerOnInit={false}
                            >
                                <TransformComponent wrapperClass="w-full">
                                    <img
                                        src={fileUrl}
                                        alt={detail?.cmspageTitle}
                                        className="w-screen h-auto object-contain"
                                    />
                                </TransformComponent>
                            </TransformWrapper>
                        </div>
                    )
                )}
            </div>
        </Layout>
    );
};

export default MenuDetail;
